import axiosInstance from "./axiosInstance";
import {EditProfileProps} from "../types/ComponentProps";

const editUserDetail = async (
  userId: number,
  userDetails: EditProfileProps,
) => {
  const accessToken = localStorage.getItem("accessTokenGC");
  try {
    const formData = new FormData();
    formData.append("preferredName", userDetails?.preferredName ?? "");
    formData.append("pronouns", userDetails?.pronouns ?? "");
    formData.append("bio", userDetails?.bio ?? "");
    formData.append("city", userDetails?.city ?? "");
    formData.append("province", userDetails?.province ?? "");
    formData.append("country", userDetails?.country ?? "");
    formData.append("birthday", userDetails?.birthday ?? "");

    if (userDetails?.profileImage) {
      formData.append("profileImage", userDetails.profileImage);
    }

    const response = await axiosInstance.patch(
      `/api/user/${userId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response;
  } catch (error) {
    throw new Error("Error creating user");
  }
};

export default editUserDetail;
